<template>
  <div class="top-image-container">
    <img :src="imageUrl"/>
  </div>
</template>
<script>
  import imageBg from 'src/assets/images/image_bg.jpg'

  export default {
    data () {
      return {}
    },
    props: {
      imageUrl: {
        default: imageBg
      }
    },
    components: {}
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/TopImageContainer.vue